var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { SportDataGateway, BFFGateway } from "sb-bff-integration";
import { BaseDict } from "./dict";
import { EventListPresenter } from "./ui";
import { EventListPresenterState } from "./state";
import { StaticDecimalLocalizator } from "../../helpers";
import { Parser } from "../../Parser";
import { Retriever } from "../../Retriever";
import { BaseBlock, broadcastBlockLoad } from "sb-resp-block-lib";
import { DeviceChangeDispatcherMock } from "sb-resp-utils";
import { Piper } from "../../piper";
import { cmsConfig } from "./config";
var _localMocks;
var EventListOptionsMock, BffGatewayMock, SportDataGatewayMock, deviceChangeDispatcherMock;
if (process.env.NODE_ENV === "development") {
    _localMocks = require("../../mocks/");
    EventListOptionsMock = _localMocks.EventListOptionsMock;
    BffGatewayMock = _localMocks.BffGatewayMock;
    SportDataGatewayMock = _localMocks.SportDataGatewayMock;
}
var EventListPresenterRoot = /** @class */ (function (_super) {
    __extends(EventListPresenterRoot, _super);
    // constructor sets defaults
    function EventListPresenterRoot(domId, options) {
        var _this = _super.call(this, domId, options) || this;
        var bffGateway, sportsDataGateway;
        if (process.env.NODE_ENV === "development") {
            _this.options = EventListOptionsMock;
            bffGateway = new BffGatewayMock();
            sportsDataGateway = new SportDataGatewayMock();
            deviceChangeDispatcherMock = DeviceChangeDispatcherMock.getInstance();
            _this.options.navHandler.Navigation = {
                adjustPath: function (url) { return "en/sports/" + url; },
                getLiveEventLink: function (id) { return "en/live-betting/#" + id; },
                getLiveBettingLink: function () { return "en/live-betting"; }
            };
            _this.options.navHandler.OpenLeague = function () { };
            // bffGateway = new BFFGateway();
            // sportsDataGateway = new SportDataGateway();
            window["EventListPresenterDATA"] = _this.dataProvider;
        }
        if (process.env.NODE_ENV === "production" && typeof options.dataProvider !== "undefined") {
            _this.options = options;
            bffGateway = new BFFGateway().withBlockId(_this.options.cms.BlockId);
            sportsDataGateway = new SportDataGateway();
            StaticDecimalLocalizator.initialize(window["BetFormat"], window["DefaultNumberFormat"]);
        }
        _this.options.dict = __assign({}, BaseDict, (_this.options.dict || {}));
        _this.options.cms = __assign({}, cmsConfig, (_this.options.cms || {}));
        _this.dataProvider = new EventListPresenterState(new Parser(new Retriever(bffGateway, sportsDataGateway, _this.options.dataProvider, deviceChangeDispatcherMock), new Piper(_this.options.dataProvider.pipeline), _this.getAvailableRequestParams(), {
            adjustPath: _this.options.navHandler.Navigation.adjustPath,
            adjustLivePath: _this.options.navHandler.Navigation.getLiveEventLink
        }, _this.options.dataProvider.specialLeagues, {
            topicPrefix: _this.options.cms.BlockId,
            clientId: _this.options.cms.BetRadarStatisticClientId,
            hasSettlementDate: _this.options.cms.hasSettlementDate,
            sortIPTopLeaguesFirst: _this.options.cms.SortIPTopLeaguesFirst,
            showStatisticsIcon: _this.options.cms.ShowStatisticsIcon
        }), _this.options);
        return _this;
    }
    EventListPresenterRoot.prototype.activate = function () {
        return _super.prototype.activate.call(this, React.createElement(EventListPresenter, { dataProvider: this.dataProvider, dict: this.options.dict, cms: this.options.cms }));
    };
    EventListPresenterRoot.prototype.beforeActivate = function () {
        this.dataProvider.activate();
        return this;
    };
    EventListPresenterRoot.prototype.beforeDeactivate = function () {
        this.dataProvider.deactivate();
        return this;
    };
    EventListPresenterRoot.prototype.setParams = function (sportId) {
        this.dataProvider.provider.setParams([sportId]);
    };
    EventListPresenterRoot.prototype.getAvailableRequestParams = function () {
        var sportIds = [], dateRange;
        if (this.options.dataProvider.eventsRequest) {
            sportIds = this.options.dataProvider.eventsRequest.request.ids;
            dateRange = this.options.dataProvider.eventsRequest.request.dateRange;
        }
        else if (this.options.dataProvider.eventsRequestOutrights) {
            sportIds = this.options.dataProvider.eventsRequestOutrights.request.ids;
            dateRange = this.options.dataProvider.eventsRequestOutrights.request.dateRange;
        }
        return {
            sportIds: sportIds,
            allSportIds: this.options.dataProvider.allSportIds,
            dateRange: dateRange
        };
    };
    return EventListPresenterRoot;
}(BaseBlock));
export { EventListPresenterRoot };
window["EventListPresenter"] = EventListPresenterRoot;
broadcastBlockLoad("EventListPresenter");
//# sourceMappingURL=index.js.map